import { lazy } from 'react';

const LazyCompareFundWrapper = lazy(() =>
  import(/* webpackChunkName: "compare-fund-wrapper" */ './CompareFundWrapper'));

export default LazyCompareFundWrapper;
